// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"cccb9f87","453":"2abb9c0b","673":"ffae0556","718":"fe9b5d7a","900":"846e2ceb"}[chunkId] + ".chunk.js";
};